import React from "react";
import SEO from "@src/components/SEO";
import OpenGraph from "@src/assets/images/sparks/opengraph.jpg";
import { SPARKS_TWITTER_IMAGE_URL } from "@src/components/partials/sparks/constants";
import { SparksPaywallExperience } from "@src/components/partials/sparks-mds/paywall/SparksPaywallExperience";
import { SparksTestModeBanner } from "@src/components/partials/sparks/SparksTestModeBanner";
import type { PageProps } from "gatsby";

const SparksPaywall = ({ location }: PageProps) => {
  return (
    <>
      <SEO
        image={OpenGraph}
        noindex={true}
        title="Dojo Sparks"
        description="Get started with Dojo Sparks."
        twitter={{ image: SPARKS_TWITTER_IMAGE_URL }}
      />
      <SparksPaywallExperience search={location.search} />
      <SparksTestModeBanner />
    </>
  );
};

export default SparksPaywall;
